import { memo } from 'react';
import { Row, Col, Container } from "react-bootstrap";
import { BzButton } from '../../../../components';



const Mandate = ({ mandate }) => {

    return (

        <>
            <Container fluid className='p-0'>
                <Row className='g-0 pt-3'>
                    <Col md={6} className='mrgauto'>
                        <Row className='g-0'>
                            <Col className='d-flex justify-content-start align-items-center'>
                                <div className='d-flex'>
                                    <div className='font-regular font-size1 color-subtext pe-1'>Auto Debit From:</div>
                                    <div className='font-medium font-size1 color-text pe-2'>Axis Bank</div>
                                </div>
                                <div className='d-flex'>
                                    <div className='font-regular font-size1 color-subtext pe-1'>Mandate ID:</div>
                                    <div className='font-regular font-size1 color-subtext pe-3'>88888888</div>
                                </div>
                                <div className='font-medium font-size1 color-primary'>Change</div>
                            </Col>
                            <Col className='d-flex justify-content-end align-items-center'>
                                <div className='font-regular font-size1 color-subtext pe-1'>Limit Available:</div>
                                <div className='font-medium font-size1 color-text'>20,000</div>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row className='g-0'>
                    <Col md={6} className='mrgauto'>
                        <Row className='g-0 my-3'>
                            <Col className='d-flex justify-content-start align-items-center'>
                                <div className='chips-wrap'>
                                    <div className='chips positive-chip me-2'>INPROCESS</div>
                                </div>
                            </Col>
                            <Col className='d-flex justify-content-end align-items-center'>
                                <BzButton className='btn btn-sm btn-primary btn-rounded'>Download</BzButton>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row className='g-0'>
                    <Col md={6} className='mrgauto'>
                        <Row className='g-0 mb-3'>
                            <Col>
                                <table className='table table-hover table-bordered'>
                                    <tbody>
                                        <tr>
                                            <th className='text-left'>
                                                <div className='font-size2 color-text text-capitalize py-2'>Bank</div>
                                            </th>
                                            <td className='text-left'>
                                                <div className='font-regular font-size2 color-text text-capitalize py-2'>{mandate[0]?.bank}</div>
                                            </td>
                                            <th className='text-left'>
                                                <div className='font-size2 color-text text-capitalize py-2'>MICR CODE</div>
                                            </th>
                                            <td className='text-left'>
                                                <div className='font-regular font-size2 color-text text-capitalize py-2'>{mandate[0]?.micrcode}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th className='text-left'>
                                                <div className='font-size2 color-text text-capitalize py-2'>ID</div>
                                            </th>
                                            <td className='text-left'>
                                                <div className='font-regular font-size2 color-text text-capitalize py-2'>{mandate[1]?._id}</div>
                                            </td>
                                            <th className='text-left'>
                                                <div className='font-size2 color-text text-capitalize py-2'>Mandate Start Date</div>
                                            </th>
                                            <td className='text-left'>
                                                <div className='font-regular font-size2 color-text text-capitalize py-2 '>{mandate[1]?.mandateStartDate}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th className='text-left'>
                                                <div className='font-size2 color-text text-capitalize py-2'>A/C Type - Number</div>
                                            </th>
                                            <td className='text-left'>
                                                <div className='font-regular font-size2 color-text text-capitalize py-2'>{mandate[2]?.ac_type_number}</div>
                                            </td>
                                            <th className='text-left'>
                                                <div className='font-size2 color-text text-capitalize py-2'>A/C Type - Number</div>
                                            </th>
                                            <td className='text-left'>
                                                <div className='font-regular font-size2 color-text text-capitalize py-2'>{mandate[2]?.mandateEndDate}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th className='text-left'>
                                                <div className='font-size2 color-text text-capitalize py-2'>Last Updated</div>
                                            </th>
                                            <td className='text-left'>
                                                <div className='font-regular font-size2 color-text text-capitalize py-2'>{mandate[3]?.lastUpdated}</div>
                                            </td>
                                            <th className='text-left'>
                                                <div className='font-size2 color-text text-capitalize py-2'>Remarks</div>
                                            </th>
                                            <td className='text-left'>
                                                <div className='font-regular font-size2 color-text text-capitalize py-2'>{mandate[3]?.remarks}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th className='text-left'>
                                                <div className='font-size2 color-text text-capitalize py-2'>IFSC Code</div>
                                            </th>
                                            <td className='text-left'>
                                                <div className='font-regular font-size2 color-text text-capitalize py-2'>{mandate[4]?.ifscCode}</div>
                                            </td>
                                            <th className='text-left'>
                                                <div className='font-size2 color-text text-capitalize py-2'>Mandate Typ</div>
                                            </th>
                                            <td className='text-left'>
                                                <div className='font-regular font-size2 color-text text-capitalize py-2'>{mandate[4]?.mandateType}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default memo(Mandate);